export enum OwnerSegment {
    FCNUVEM_LOUSADA = 1,
    FCNUVEM_TIAGO = 2,
    OMNI_FINANCE = 3,
    OMNI_PISANE = 4,
    OMNI_MAZZINI = 5,
    OMNI_LOHAIN = 6,
    EXPONENTIAL_NICOLE = 7,
    EXPONENTIAL_LYSSA = 8,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/OwnerSegment.ts